import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Button, Row, Col, Spinner, Form } from 'react-bootstrap';
import { FiList } from 'react-icons/fi';
import {
  FaFilter,
  FaBuilding,
  FaCalendar,
  FaCalendarPlus,
  FaEye,
  FaEyeSlash,
  FaLink,
} from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { UserList, ChartBarHorizontal, UserPlus } from 'phosphor-react';
import Select from 'react-select';
import ProspectoBuscaFormulario from '~/Components/Prospectos/ProspectoBusca/ProspectoBuscaFormulario';
import Outsider from '~/Components/Outsider';
import { Avatar } from '~/Pages/Prospectos/styles';
import { AvatarImage } from '~/Styles';
import { ContainerBusca, DesktopNavbarGrid } from './styles';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import ModalLinkCadastro from '~/Components/Prospectos/ModalLinkCadastro';

export default function ProspectosNavbar({
  filterIsDirty,
  isSearchActive,
  setSearchActive,
  filtros,
  visualizarGerentes,
  imobiliarias,
  visualizarCorretores,
  corretoresSelecionaveis,
  onSubmitSearch,
  onResetSearch,
  empreendimentos,
  isLoading,
  handleChangeFiltro,
  tipoFiltroEtapa,
  onChangeLayout,
  layoutSelecionado,
}) {
  const [filtroCorretor, setFiltroCorretor] = useState('');
  const [corretoresFiltrados, setCorretoresFiltrados] = useState([]);
  const [exibirSidebar, setExibirSidebar] = useState(false);
  const [showModalLink, setShowModalLink] = useState(false);

  const toggleSidebar = () => {
    setExibirSidebar(!exibirSidebar);
  };

  useEffect(() => {
    if (corretoresFiltrados.length === 0) {
      setCorretoresFiltrados(corretoresSelecionaveis);
    }
  }, [corretoresSelecionaveis]);

  useEffect(() => {
    setCorretoresFiltrados(
      corretoresSelecionaveis
        .filter(
          item =>
            !filtros.codigo_gerente ||
            item.codigo_gerente === filtros.codigo_gerente
        )
        .filter(item => {
          return (
            !filtroCorretor ||
            item.nome.toLowerCase().includes(filtroCorretor.toLowerCase())
          );
        })
    );
  }, [filtros, filtroCorretor, corretoresSelecionaveis]);

  const imobiliariaSelecionada = imobiliarias.find(
    item => item.codigo === filtros.codigo_gerente
  );
  const corretorSelecionado = corretoresSelecionaveis.find(
    item => item.codigo === filtros.codigo_corretor
  );

  function onClickSelecionaCorretor(codigo_corretor) {
    onSubmitSearch({ ...filtros, codigo_corretor });
  }

  function onClickSelecionaGerente(codigo_gerente) {
    onSubmitSearch({ ...filtros, codigo_gerente });
  }

  const handleSubmitSearch = values => {
    onSubmitSearch(values);
    setExibirSidebar(false);
  };

  // Opções dos selects
  const imobiliariasOptions = [
    {
      value: '',
      label: 'Todas Imobiliárias',
      icon: <FaBuilding color="#000" />,
    },
    ...imobiliarias.map(imobiliaria => ({
      value: imobiliaria.codigo,
      label: imobiliaria.nome,
      icon: (
        <Avatar>
          <AvatarImage src={imobiliaria.logo} alt={imobiliaria.nome} />
        </Avatar>
      ),
    })),
  ];

  const corretoresOptions = [
    { value: '', label: 'Todos Corretores', icon: <UserList color="#000" /> },
    ...corretoresFiltrados.map(corretor => ({
      value: corretor.codigo,
      label: corretor.nome.split(/(\s).+\s/).join(''),
      icon: (
        <Avatar>
          <AvatarImage src={corretor.foto} alt={corretor.nome} />
        </Avatar>
      ),
    })),
  ];

  const layoutOptions = [
    { value: 'geral', label: 'Visão Geral', icon: <FaEye color="#000" /> },
    {
      value: 'corretor',
      label: 'Visão Corretor',
      icon: <FaEyeSlash color="#000" />,
    },
  ];

  const formatOptionLabel = ({ label, icon }) => (
    <div className="d-flex align-items-center">
      {icon}
      <span className="ml-2">{label}</span>
    </div>
  );

  const buttonStyle = {
    background: '#419AEF',
    borderColor: '#419AEF',
    fontFamily: 'Open Sans, Arial, sans-serif',
  };

  return (
    <Outsider onClickOut={() => setSearchActive(false)}>
      <Container fluid className="py-2 px-2 px-md-3">
        {/* Layout Desktop (lg+): Tudo em uma linha */}
        <DesktopNavbarGrid>
          <div
            className="d-flex align-items-center"
            style={{ gap: '0.5rem', flexWrap: 'nowrap', overflow: 'hidden' }}
          >
              <Button
                variant="outline-secondary"
                size="sm"
                title="Visão Kanban"
                active
              >
                <ChartBarHorizontal />
              </Button>
              <Link
                className="btn btn-sm btn-outline-secondary"
                title="Visão Lista"
                to="/prospectos/lista"
              >
                <FiList />
              </Link>
              {isLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <Button
                  variant="primary"
                  size="sm"
                  onClick={toggleSidebar}
                  style={{
                    ...(isLoading && {
                      pointerEvents: 'none',
                      opacity: 0.6,
                      backgroundColor: '#419AEF',
                      color: '#fff',
                    }),
                    ...buttonStyle,
                    position: 'relative',
                  }}
                >
                  <FaFilter
                    size={14}
                    style={{ stroke: '#fff', strokeWidth: 32 }}
                  />
                  <span className="ml-1">Filtros</span>
                  {filtros.filtro_side_bar === '1' && (
                    <span
                      style={{
                        position: 'absolute',
                        top: '-4px',
                        right: '-4px',
                        width: '14px',
                        height: '14px',
                        backgroundColor: 'red',
                        borderRadius: '50%',
                        border: '2px solid #fff',
                      }}
                    />
                  )}
                </Button>
              )}
              <Link
                className={`btn btn-primary btn-sm ${
                  isLoading ? 'disabled' : ''
                }`}
                to={isLoading ? '#' : { search: '?novo=true' }}
                style={{
                  ...buttonStyle,
                  display: 'inline-flex',
                  alignItems: 'center',
                  ...(isLoading && { pointerEvents: 'none', opacity: 0.6 }),
                }}
                title="Adicionar Prospecto"
              >
                {isLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <>
                    <UserPlus />
                    <span className="ml-1">Adicionar</span>
                  </>
                )}
              </Link>
              <Link
                className="btn btn-primary btn-sm"
                to="/agenda/true"
                style={{
                  ...buttonStyle,
                  display: 'inline-flex',
                  alignItems: 'center',
                }}
                title="Visualizar minha agenda"
              >
                <FaCalendar style={{ stroke: '#fff', strokeWidth: 32 }} />
                <span className="ml-1">Minha Agenda</span>
              </Link>
              <Button
                variant="primary"
                size="sm"
                onClick={() => setShowModalLink(true)}
                style={{
                  ...buttonStyle,
                  display: 'inline-flex',
                  alignItems: 'center',
                }}
                title="Gerar link de cadastro"
              >
                <FaLink style={{ stroke: '#fff', strokeWidth: 32 }} />
                <span className="ml-1">Link de Cadastro</span>
              </Button>
              {AuthStorage.temCaracteristica(caracteristicas.AtendenteCav) && (
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => (window.location.href = '/agenda/false')}
                  style={{
                    ...buttonStyle,
                    display: 'inline-flex',
                    alignItems: 'center',
                  }}
                >
                  <FaCalendarPlus color="#fff" size={16} />
                  <span className="ml-1">Agenda Completa</span>
                </Button>
              )}
              {AuthStorage.temCaracteristica(
                caracteristicas.FaseConstrucao
              ) && (
                <Form.Check
                  type="switch"
                  id="toggle-etapa-desktop"
                  label={
                    tipoFiltroEtapa === 'etapaProspectoTerrenoConstrucao'
                      ? 'Etapa Construção'
                      : 'Etapa Prospecto'
                  }
                  checked={
                    tipoFiltroEtapa === 'etapaProspectoTerrenoConstrucao'
                  }
                  onChange={() =>
                    handleChangeFiltro(
                      tipoFiltroEtapa === 'etapaProspectoTerrenoConstrucao'
                        ? 'etapaProspectoPadrao'
                        : 'etapaProspectoTerrenoConstrucao'
                    )
                  }
                  className="ml-2 mb-0"
                />
              )}
          </div>

          {/* Selects */}
          <div
            className="d-flex align-items-center"
            style={{ gap: '0.5rem', flexWrap: 'nowrap' }}
          >
              <div style={{ minWidth: '180px' }}>
                <Select
                  isSearchable
                  isDisabled={layoutOptions.length <= 1}
                  options={layoutOptions}
                  value={
                    layoutOptions.find(
                      opt => opt.value === layoutSelecionado
                    ) || layoutOptions[0]
                  }
                  onChange={option => onChangeLayout(option.value)}
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  formatOptionLabel={formatOptionLabel}
                />
              </div>
              {visualizarGerentes && (
                <div style={{ minWidth: '200px' }}>
                  <Select
                    isSearchable
                    isDisabled={isLoading || imobiliariasOptions.length <= 1}
                    options={imobiliariasOptions}
                    value={
                      imobiliariaSelecionada
                        ? {
                            value: imobiliariaSelecionada.codigo,
                            label: imobiliariaSelecionada.nome,
                            icon: (
                              <Avatar>
                                <AvatarImage
                                  src={imobiliariaSelecionada.logo}
                                  alt={imobiliariaSelecionada.nome}
                                />
                              </Avatar>
                            ),
                          }
                        : imobiliariasOptions[0]
                    }
                    onChange={option =>
                      onClickSelecionaGerente(option.value || null)
                    }
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                    formatOptionLabel={formatOptionLabel}
                  />
                </div>
              )}
              {visualizarCorretores && (
                <div style={{ minWidth: '200px' }}>
                  <Select
                    isSearchable
                    isDisabled={isLoading || corretoresOptions.length <= 1}
                    options={corretoresOptions}
                    value={
                      corretorSelecionado
                        ? {
                            value: corretorSelecionado.codigo,
                            label: corretorSelecionado.nome
                              .split(/(\s).+\s/)
                              .join(''),
                            icon: (
                              <Avatar>
                                <AvatarImage
                                  src={corretorSelecionado.foto}
                                  alt={corretorSelecionado.nome}
                                />
                              </Avatar>
                            ),
                          }
                        : corretoresOptions[0]
                    }
                    onChange={option =>
                      onClickSelecionaCorretor(option.value || null)
                    }
                    placeholder="Todos Corretores"
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                    formatOptionLabel={formatOptionLabel}
                    onInputChange={setFiltroCorretor}
                    inputValue={filtroCorretor}
                  />
                </div>
              )}
          </div>
        </DesktopNavbarGrid>

        {/* Layout Mobile/Tablet (< lg): Botões em cima, selects embaixo */}
        <div className="d-lg-none">
          {/* Linha de Botões */}
          <div
            className="d-flex flex-wrap align-items-center mb-2"
            style={{ gap: '0.5rem' }}
          >
            <Button
              variant="outline-secondary"
              size="sm"
              title="Visão Kanban"
              active
            >
              <ChartBarHorizontal />
            </Button>
            <Link
              className="btn btn-sm btn-outline-secondary"
              title="Visão Lista"
              to="/prospectos/lista"
            >
              <FiList />
            </Link>
            <Button
              variant="primary"
              size="sm"
              onClick={toggleSidebar}
              style={{ ...buttonStyle, position: 'relative' }}
            >
              <FaFilter size={14} style={{ stroke: '#fff', strokeWidth: 32 }} />
              {filtros.filtro_side_bar === '1' && (
                <span
                  style={{
                    position: 'absolute',
                    top: '-4px',
                    right: '-4px',
                    width: '14px',
                    height: '14px',
                    backgroundColor: 'red',
                    borderRadius: '50%',
                    border: '2px solid #fff',
                  }}
                />
              )}
            </Button>
            <Link
              className={`btn btn-primary btn-sm ${
                isLoading ? 'disabled' : ''
              }`}
              to={isLoading ? '#' : { search: '?novo=true' }}
              style={{
                ...buttonStyle,
                ...(isLoading && { pointerEvents: 'none', opacity: 0.6 }),
              }}
              title="Adicionar Prospecto"
            >
              {isLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <UserPlus />
              )}
            </Link>
            <Link
              className="btn btn-primary btn-sm"
              to="/agenda/true"
              style={buttonStyle}
              title="Visualizar minha agenda"
            >
              <FaCalendar style={{ stroke: '#fff', strokeWidth: 32 }} />
            </Link>
            <Button
              variant="primary"
              size="sm"
              onClick={() => setShowModalLink(true)}
              style={buttonStyle}
              title="Gerar link de cadastro"
            >
              <FaLink style={{ stroke: '#fff', strokeWidth: 32 }} />
            </Button>
            {AuthStorage.temCaracteristica(caracteristicas.AtendenteCav) && (
              <Button
                variant="primary"
                size="sm"
                onClick={() => (window.location.href = '/agenda/false')}
                style={buttonStyle}
              >
                <FaCalendarPlus color="#fff" size={16} />
              </Button>
            )}
            {AuthStorage.temCaracteristica(caracteristicas.FaseConstrucao) && (
              <Form.Check
                type="switch"
                id="toggle-etapa-mobile"
                label={
                  tipoFiltroEtapa === 'etapaProspectoTerrenoConstrucao'
                    ? 'Construção'
                    : 'Prospecto'
                }
                checked={tipoFiltroEtapa === 'etapaProspectoTerrenoConstrucao'}
                onChange={() =>
                  handleChangeFiltro(
                    tipoFiltroEtapa === 'etapaProspectoTerrenoConstrucao'
                      ? 'etapaProspectoPadrao'
                      : 'etapaProspectoTerrenoConstrucao'
                  )
                }
                className="mb-0"
              />
            )}
          </div>

          {/* Linha de Selects - 2 lado a lado */}
          <Row className="mb-2">
            <Col xs={6} className="pr-1">
              <Select
                isSearchable
                isDisabled={layoutOptions.length <= 1}
                options={layoutOptions}
                value={
                  layoutOptions.find(opt => opt.value === layoutSelecionado) ||
                  layoutOptions[0]
                }
                onChange={option => onChangeLayout(option.value)}
                styles={customStyles}
                components={{ DropdownIndicator }}
                formatOptionLabel={formatOptionLabel}
              />
            </Col>
            {visualizarGerentes && (
              <Col xs={6} className="pl-1">
                <Select
                  isSearchable
                  isDisabled={isLoading || imobiliariasOptions.length <= 1}
                  options={imobiliariasOptions}
                  value={
                    imobiliariaSelecionada
                      ? {
                          value: imobiliariaSelecionada.codigo,
                          label: imobiliariaSelecionada.nome,
                          icon: (
                            <Avatar>
                              <AvatarImage
                                src={imobiliariaSelecionada.logo}
                                alt={imobiliariaSelecionada.nome}
                              />
                            </Avatar>
                          ),
                        }
                      : imobiliariasOptions[0]
                  }
                  onChange={option =>
                    onClickSelecionaGerente(option.value || null)
                  }
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  formatOptionLabel={formatOptionLabel}
                />
              </Col>
            )}
          </Row>

          {/* Terceiro Select - Linha separada (largura total) */}
          {visualizarCorretores && (
            <Row>
              <Col xs={12}>
                <Select
                  isSearchable
                  isDisabled={isLoading || corretoresOptions.length <= 1}
                  options={corretoresOptions}
                  value={
                    corretorSelecionado
                      ? {
                          value: corretorSelecionado.codigo,
                          label: corretorSelecionado.nome
                            .split(/(\s).+\s/)
                            .join(''),
                          icon: (
                            <Avatar>
                              <AvatarImage
                                src={corretorSelecionado.foto}
                                alt={corretorSelecionado.nome}
                              />
                            </Avatar>
                          ),
                        }
                      : corretoresOptions[0]
                  }
                  onChange={option =>
                    onClickSelecionaCorretor(option.value || null)
                  }
                  placeholder="Todos Corretores"
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  formatOptionLabel={formatOptionLabel}
                  onInputChange={setFiltroCorretor}
                  inputValue={filtroCorretor}
                />
              </Col>
            </Row>
          )}
        </div>
      </Container>

      {/* Search Ativo */}
      {isSearchActive && (
        <ContainerBusca>
          <Container className="ml-5">
            <Row>
              <Col>
                <ProspectoBuscaFormulario
                  onSubmit={onSubmitSearch}
                  onReset={onResetSearch}
                  filter={filtros}
                  empreendimentos={empreendimentos}
                  filterIsDirty={filterIsDirty}
                  exibirFiltroEtapa={false}
                  exibirFiltroGerenteCorretor={false}
                />
              </Col>
            </Row>
          </Container>
        </ContainerBusca>
      )}

      {/* Overlay do Sidebar */}
      {exibirSidebar && (
        <div
          onClick={toggleSidebar}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.3)',
            zIndex: 1049,
            transition: 'opacity 0.3s',
          }}
        />
      )}

      {/* Sidebar de Filtros */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          width: '100%',
          maxWidth: 480,
          height: '100%',
          background: '#fff',
          boxShadow: '-2px 0 8px rgba(0,0,0,0.1)',
          zIndex: 1050,
          overflowY: 'auto',
          transition: 'transform 0.3s',
          transform: exibirSidebar ? 'translateX(0)' : 'translateX(100%)',
          pointerEvents: exibirSidebar ? 'auto' : 'none',
        }}
        className="p-3 p-sm-4"
      >
        <Button
          variant="light"
          className="mb-3"
          onClick={toggleSidebar}
          style={{ float: 'right' }}
        >
          <MdClose size={20} />
        </Button>
        <div style={{ clear: 'both' }}>
          <ProspectoBuscaFormulario
            onSubmit={handleSubmitSearch}
            onReset={onResetSearch}
            filter={filtros}
            empreendimentos={empreendimentos}
            filterIsDirty={filterIsDirty}
            exibirFiltroEtapa={true}
            exibirFiltroGerenteCorretor={true}
          />
        </div>
      </div>
      <ModalLinkCadastro
        show={showModalLink}
        onHide={() => setShowModalLink(false)}
        empreendimentos={empreendimentos}
      />
    </Outsider>
  );
}
